import React, { useEffect } from 'react'

function MainSlideCard({data}) {
   
  return (
    <div className='relative w-full h-[100vh] max-[1000px]:h-full min-h-[200px]'>
        <img className='w-full h-full min-h-full' src={data?.image_full_url} />
       
    </div>
  )
}

export default MainSlideCard